import React, { useState } from 'react'
import { LuPencil } from 'react-icons/lu'

import Invitee from '@/components/integration/nylas/scheduler/components/summary/Invitee'
import ParticipantsModal from '@/components/integration/nylas/scheduler/components/summary/ParticipantsModal'
import { useSchedulerConfig } from '@/components/integration/nylas/scheduler/context/SchedulerConfigContext'
import { useSchedulerSelection } from '@/components/integration/nylas/scheduler/context/SchedulerSelectionContext'
import { Button } from '@/components/ui/button'

const InviteesCell: React.FC = () => {
  const { primaryParticipant } = useSchedulerConfig()
  const { guests, setGuests, setFinalPrimaryParticipant } =
    useSchedulerSelection()
  const [showParticipantsModal, setShowParticipantsModal] = useState(false)

  return (
    <div className="flex flex-col items-start gap-2">
      <Invitee
        name={primaryParticipant.name}
        email={primaryParticipant.email}
      />

      {guests.map((participant) => (
        <Invitee
          key={participant.email}
          name={participant.name}
          email={participant.email}
        />
      ))}

      <Button
        variant="outline-primary"
        size="xs"
        onClick={() => setShowParticipantsModal(true)}
      >
        <LuPencil /> Change
      </Button>

      {showParticipantsModal && (
        <ParticipantsModal
          primaryParticipant={primaryParticipant}
          guests={guests}
          onSubmit={(newParticipants) => {
            setGuests(newParticipants.guests)
            setFinalPrimaryParticipant({
              name: newParticipants.name,
              email: newParticipants.email,
            })
            setShowParticipantsModal(false)
          }}
          onHide={() => setShowParticipantsModal(false)}
        />
      )}
    </div>
  )
}

export default InviteesCell
